export default __webpack_public_path__ + "static/media/Img5.44a06658.jpg";